import { ScrollAreaRoot } from "./ScrollAreaRoot";

export const ScrollArea = {
  Root: ScrollAreaRoot,
}
